import { Button } from 'react-bootstrap'
import searchIcon from '../../../../images/Action/Search.png'
import { TbListSearch } from 'react-icons/tb'
import { formatNumber } from "../func/display"

export const columns = [
  {
    header: 'Name',
    minWidth: '384px',
    headerStyle: { textAlign: 'left', verticalAlign: 'middle' }
  },
  {
    header: 'Location (Lat., Long.)',
    minWidth: '196px',
    headerStyle: { textAlign: 'left', verticalAlign: 'middle' }
  },
  {
    header: 'Radius (m.)',
    className: 'text-center',
    minWidth: '118px',
    headerStyle: { textAlign: 'center', verticalAlign: 'middle' }
  },
  {
    header: 'Remark',
    minWidth: '250px',
    headerStyle: { textAlign: 'left', verticalAlign: 'middle' }
  },
  {
    header: 'Status',
    className: 'text-center',
    minWidth: '86px',
    headerStyle: { textAlign: 'center', verticalAlign: 'middle' }
  },
  {
    header: 'Action',
    className: 'text-center',
    minWidth: '118px',
    headerStyle: { textAlign: 'center', verticalAlign: 'middle' }
  }
]

export const renderLocationRow = (
  location,
  index,
  borderStyle,
  onEdit,
  activeTab,
  t
) => {
  const nameCellStyle = (minWidth) => ({
    ...borderStyle,
    minWidth,
    textAlign: 'left',
    verticalAlign: 'middle'
  })

  const centerCellStyle = (minWidth) => ({
    ...borderStyle,
    minWidth,
    textAlign: 'center',
    verticalAlign: 'middle'
  })

  return (
    <>
      <td style={nameCellStyle('384px')}>
        <p
          className="mb-0 font-small-2"
          style={{
            color: ' var(--color-on-base-content-high)'
          }}
        >
          {location.office_location_name || '-'}
        </p>
      </td>

      <td style={nameCellStyle('196px')}>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${location.office_location_lat},${location.office_location_lon}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block", 
            textDecoration: "none",
            color: "var(--color-primary-content-default, #2C5DFE)",
          }}
        >
          <p className="mb-0 font-small-2">
            {`${location.office_location_lat},`}
          </p>
          <p className="mb-0 font-small-2">
            {`${location.office_location_lon}`}
          </p>
        </a>
      </td>

      <td style={centerCellStyle('118px')}>
        <p
          className="mb-0 font-small-2"
          style={{
            color: ' var(--color-on-base-content-high)'
          }}
        >
          {formatNumber(location.office_location_radius)}
        </p>
      </td>

      <td style={nameCellStyle('250px')}>
        <p
          className="mb-0 font-small-2"
          style={{
            color: ' var(--color-on-base-content-high)'
          }}
        >
          {location.office_location_remark || '-'}
        </p>
      </td>

      <td style={centerCellStyle('86px')}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',

            minWidth: '98px',
            height: '26px',
            padding: '0 10px',
            borderRadius: '6px',

            backgroundColor: location.office_location_status
              ? 'var(--color-functional-foreground-success-subtle)'
              : 'var(--color-functional-foreground-error-subtle)',
            color: location.office_location_status
              ? 'var(--color-functional-content-success)'
              : 'var(--color-functional-content-error)',

            fontSize: '12px',
            fontWeight: 500,
            boxSizing: 'border-box'
          }}
        >
          {location.office_location_status
            ? t('hrms_setting_location_active_status')
            : t('hrms_setting_location_inactive_status')}
        </span>
      </td>

      <td style={centerCellStyle('118px')}>
        <Button
          variant="light"
          className="text-primary rounded-2 px-2 me-2"
          style={{
            width: '40px',
            height: '32',
            marginTop: '2px',
            borderColor: 'var(--color-on-base-border-default)',
            backgroundColor: 'var(--color-base-foreground-elevated-16)'
          }}
          size="sm"
          onClick={() => onEdit?.(location.office_location_id, activeTab)}
        >
          <TbListSearch
            size={18}
            style={{
              color: 'var(--color-on-base-content-high)'
            }}
          />
        </Button>
      </td>
    </>
  )
}

export const locationListFields = (type, options) => {
  const searchField = {
    name: 'searchList',
    label: '',
    // placeholder: "Search by Location Name (TH or EN)",
    type: 'text',
    required: false,
    fullWidth: true,
    icons: searchIcon
  }

  const selectField = {
    name: 'selectOrgs',
    label: '',
    placeholder: '',
    type: 'select',
    required: false,
    fullWidth: true,
    options: options
  }

  if (type === 'list') {
    return [searchField]
  }

  return [selectField, searchField]
}
